import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export default function Refund() {
  return (
    <div>
    <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
        </a>

        <ul id="nav" className="nav">
            <li className="current">
                <Link to="/">Home</Link>

            </li>
            <li>
                <Link to="/">                About
                </Link>
            </li>

            <li>
                <Link to="/">                Contact
                </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">Terms and conditions</Link>

            </li>
            <li>
              <Link to="/privacy-policy">PrivacyPolicy</Link>

            </li>
            <li>
              <Link to="/return-policy">Return and refund</Link>
            </li>

        </ul>
    </nav>
    <section id="resume">
        <div className="row education">
            <h2>Refund Policy</h2>
             <p>Last Updated: 01-01-2024</p>
             <p>Thank you for choosing Yogesh Sharma for your website development needs.

We take pride in delivering high-quality digital services, and your satisfaction is our top priority. Please read this policy carefully before engaging with our services.</p>
              <h3>
              Refund Eligibility
              </h3>
            <ol>
                <li>
                    <h3>Cancellation Before Commencement: </h3>
                    <p>
                    If you decide to cancel your project before any work has commenced, you are eligible for a full refund.                    </p>
                </li>

                <li>
                    <h3>Work in Progress:</h3>
                    <p>
                    Once the project has started, refunds will be considered based on the amount of work completed and the resources invested up to that point. We will provide a prorated refund after deducting any costs incurred during the development process.
                    </p>
                </li>
                <li>
                    <h3>Completed Projects</h3>
                    <p>
                    Refunds are generally not applicable for completed projects. However, we are committed to ensuring your satisfaction. If you encounter any issues or are dissatisfied with the final product, please contact us, and we will work towards a resolution.                    </p>
                </li>
                <li>
                    <h3>How to Request a Refund</h3>
                    <p>
                    To request a refund, please contact our customer support team at 9079794224. Provide your name, project details, and a clear explanation of the reason for the refund request. We will review your request promptly and respond accordingly.                    </p>
                </li>
                <h4>No Refund Situations</h4>
                <p>Refunds may not be issued in the following situations:</p>
                <li>
                    <h3>Change of Mind:</h3>
                    <p>
                     We do not offer refunds based on a change of mind once the project has commenced.

</p>
                </li>
                <li>
                    <h3>Client-Requested Changes:</h3>
                    <p>
                    If the project is delayed or disrupted due to client-requested changes, refunds may not be applicable.                    </p>
                </li>
                <li>
                    <h3>Contact Information</h3>
                    <p>
                        If you have any questions or concerns regarding these terms and conditions, please contact us at theyogeshsharma06@gmail.com.
                    </p>
                </li>
            </ol>


            <h4>NOTE:</h4>
            <p>Delivery of Digital Services

At Yogesh Sharma, we specialize in providing online services, specifically website development. As we do not deal with physical products, our delivery process is entirely digital. Upon project completion, you will receive access to the relevant digital files, login credentials, or instructions via secure online channels.

For any questions or clarifications regarding the delivery of our digital services, please contact our customer support at 9079794224.

</p>
        </div>
    </section>
</div>
  )
}
